module.exports = __webpack_public_path__ + "img/mesa_ls03j.5e0b2776.png";